import type { CohesionConfig } from '@highereducation/api-clients';
export const generateCohesionSnippet = (cohesionConfig: CohesionConfig) => {
  if (!cohesionConfig) {
    // TODO: report to new relic
    return '';
  }

  return `
!function(co,h,e,s,i,o,n){var d='documentElement';var a='className';h[d][a]+=' preampjs fusejs';
    n.k=e;co._Cohesion=n;co._Preamp={k:s,start:new Date};co._Fuse={k:i};co._Tagular={k:o};
    [e,s,i,o].map(function(x){co[x]=co[x]||function(){(co[x].q=co[x].q||[]).push([].slice.call(arguments))}});
    h.addEventListener('DOMContentLoaded',function(){co.setTimeout(function(){
    var u=h[d][a];h[d][a]=u.replace(/ ?preampjs| ?fusejs/g,'')},3e3);
    co._Preamp.docReady=co._Fuse.docReady=!0});var z=h.createElement('script');
    z.async=1;z.src='https://content.cmn.com/cohesion/cohesion-latest.min.js?cDomain=${
      cohesionConfig?.tagular.cookieDomain
    }';h.head.appendChild(z);}
    (window,document,'cohesion','preamp','fuse','tagular',{
    tagular:{
        apiHost: '${cohesionConfig?.tagular.apiHost}',
        apiKey:'${cohesionConfig?.tagular.apiKey}',
        cookieSameSite: 'Lax',
        sourceKey:'${cohesionConfig?.tagular.sourceKey}',
        writeKey:'${cohesionConfig?.tagular.writeKey}',
        cookieDomain:'${cohesionConfig?.tagular.cookieDomain}',
        domainWhitelist: ${JSON.stringify(
          cohesionConfig?.tagular.domainWhitelist,
          null,
          2,
        )},
        apiVersion:'v2/t',
        useBeacon: true,
        multiparty: ${cohesionConfig?.tagular?.multiparty},
    },
    monarch: {
        sourceId: '${cohesionConfig?.monarch.sourceId}',
        token: '${cohesionConfig?.monarch.token}',
        autoRequest: {
          enabled: true,
          suppressPlacements: true,
          timeout: 15000,
        }
    },
    consent: {
        onetrust: {
          enabled: ${cohesionConfig?.consent.onetrust.enabled},
          optIn: ${cohesionConfig?.consent.onetrust.optIn},
        },
        required: ${cohesionConfig?.consent.required},
    },
})`;
};
